import { getMetaSnapshot } from './meta';

/**
 * Shape of the Meta CAPI attribution block forwarded to the backend.
 * Mirrors the pattern that `BestellungReviewScreen` has used at
 * checkout since 2026-10-29 and that the funnel (register + book
 * order creation) adopts on 2026-10-30.
 *
 * `consentMarketing` is ALWAYS present (even when false) — the
 * backend uses it as the CAPI event gate. `fbc` / `fbp` are only
 * included when consent is true.
 */
export interface MetaAttributionPayload {
  readonly consentMarketing: boolean;
  readonly fbc?: string;
  readonly fbp?: string;
}

/**
 * Build the Meta attribution block from the current browser state.
 * Call sites: SignupRoute, LightGateOverlay (book register +
 * createBookOrder), ProbeLightGateOverlay, BestellungReviewScreen.
 * One source so the capture discipline (fbc/fbp only on consent)
 * cannot drift between forms.
 */
export function buildMetaAttributionPayload(): MetaAttributionPayload {
  const snap = getMetaSnapshot();
  return {
    consentMarketing: snap.consentMarketing,
    ...(snap.consentMarketing && snap.fbc !== null ? { fbc: snap.fbc } : {}),
    ...(snap.consentMarketing && snap.fbp !== null ? { fbp: snap.fbp } : {}),
  };
}
